/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Описывает текущий статус заявки
 * @export
 * @enum {string}
 */
export enum CurrentApplicationStatus {
  Refuse = 'Refuse',
  Registered = 'Registered',
  Fe = 'FE',
  Mktu = 'MKTU',
  Eos = 'EOS',
  CompletedEos = 'CompletedEOS',
  Egr = 'EGR',
  Create = 'Create',
  PrepereToTransfer = 'PrepereToTransfer',
}

export function instanceOfCurrentApplicationStatus(value: any): boolean {
  for (const key in CurrentApplicationStatus) {
    if (Object.prototype.hasOwnProperty.call(CurrentApplicationStatus, key)) {
      if (
        CurrentApplicationStatus[
          key as keyof typeof CurrentApplicationStatus
        ] === value
      ) {
        return true
      }
    }
  }
  return false
}

export function CurrentApplicationStatusFromJSON(
  json: any
): CurrentApplicationStatus {
  return CurrentApplicationStatusFromJSONTyped(json, false)
}

export function CurrentApplicationStatusFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CurrentApplicationStatus {
  return json as CurrentApplicationStatus
}

export function CurrentApplicationStatusToJSON(
  value?: CurrentApplicationStatus | null
): any {
  return value as any
}
